function getConfig(name, defaultValue = null) {
  
  if (window.ENV !== undefined) {
    return window.ENV[name] || defaultValue;
  }

  return import.meta.env[name] || defaultValue;
}

// Dominio proprio do link do SMS (ex.: https://simular.consigtechpromotora.com).
export function getLinkUrl() {
  return getConfig("VITE_LINK_URL") || getConfig("REACT_APP_LINK_URL");
}

export function getBackendUrl() {
  return getConfig("VITE_BACKEND_URL") || getConfig("REACT_APP_BACKEND_URL");
}

export function getHoursCloseTicketsAuto() {
  return (
    getConfig("VITE_HOURS_CLOSE_TICKETS_AUTO") ||
    getConfig("REACT_APP_HOURS_CLOSE_TICKETS_AUTO")
  );
}
